module.exports = __webpack_public_path__ + "static/media/github-logo-white.db2a6b4b.svg";